<template>
	<div canplay="app-frame">
		<router-view></router-view>
	</div>
</template>

<style lang="scss">
	.app-frame{
		overflow: hidden;
	}
</style>
